import { cap } from '../../State'
import { translations } from '../../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

export const CALL_TYPES = [
  {
    value: 'testUnit',
    label: 'Test Unit (sync, debug)',
    channel: 'debug',
    sync: true,
    init: false
  },
  {
    value: 'sendMessageApp',
    label: 'App Nora (async, init)',
    channel: 'appNora',
    sync: false,
    init: true
  },
  {
    value: 'sendMessageEmail',
    label: 'Email (async, init)',
    channel: null,
    sync: false,
    init: true
  },
  {
    value: 'sendMessageMidOffice',
    label: 'MidOffice (async)',
    channel: 'midoffice',
    sync: false,
    init: true
  },
  {
    value: 'whatsappMessage',
    label: 'WhatsApp (sync)',
    channel: 'whatsapp',
    sync: true,
    init: true
  },
  {
    value: 'frigerioFlow',
    label: 'Frigerio Flow (async)',
    channel: 'email',
    sync: false,
    init: false
  },
  {
    value: 'gattinoniFlow',
    label: 'Gattinoni Flow (async)',
    channel: 'email',
    sync: false,
    init: false
  },
  {
    value: 'goelettFlow',
    label: 'Goelett Flow (async)',
    channel: 'email',
    sync: false,
    init: false
  },
  {
    value: 'dailyBriefing',
    label: 'Daily Briefing (sync)',
    channel: 'appNora',
    sync: true,
    init: false
  }
]

export const COMMUNICATION_CHANNELS = [
  { value: 'debug', label: 'Debug' },
  { value: 'email', label: 'Email' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'midoffice', label: 'MidOffice' },
  { value: 'appNora', label: 'App Nora' },
  { value: 'front', label: 'Front' }
]

export const DEFAULT_EMAILS = [
  { label: 'mranocchia@siapcn.it', value: 'mranocchia@siapcn.it' },
  { label: 'murru@siapcn.it', value: 'murru@siapcn.it' },
  { label: 'atomatis@siapcn.it', value: 'atomatis@siapcn.it' },
  { label: 'mbolla@siapcn.it', value: 'mbolla@siapcn.it' }
]

export const FORMALITY_LEVELS = [
  { label: t.pocoFormale || 'Poco formale', value: 30 },
  { label: t.formaleDefault || 'Formale (default)', value: 75 },
  { label: t.moltoFormale || 'Molto formale', value: 100 }
]

/**
 * Flussi email per cliente: condividono lo stesso contratto di payload
 * (`mailReferencesEmail`, `subject`, `body`, `from`) sia in buildPayload sia nella
 * sezione Parametri Canale.
 */
export const EMAIL_FLOW_CALL_TYPES = ['frigerioFlow', 'gattinoniFlow', 'goelettFlow']

export const MIDOFFICE_REQUIRED_FIELDS = [
  'userInput',
  'userEmail',
  'referencesBtmEmail',
  'pid',
  'codiceCliente',
  'tomcatCode',
  'codSociety',
  'isola'
]

export const DEFAULT_STATE = {
  callType: 'testUnit',
  unit: 'newMessage',
  communicationChannel: 'debug',
  isDebug: true,
  pdfQuotes: false,
  levelFormalita: 75,
  userEmail: 'mranocchia@siapcn.it',
  operatorEmail: 'mranocchia@siapcn.it',
  selectedEnvironment: '',
  codSociety: '',
  tomcatCode: '',
  selectedPID: '',
  referencesBtmEmail: { idConversazione: '', emailIsola: '', subject: '' },
  referenceWhatsapp: { from: '', id: '' },
  mailReferencesEmail: { idConversazione: '', emailIsola: '', subject: '' },
  codiceCliente: '',
  isola: '',
  subject: '',
  body: '',
  customJson: '',
  showPayloadPreview: false,
  audioMessage: false,
  sendEmail: false
}

export const PRESET_STORAGE_KEY = 'nora-debug-presets'
export const COLLAPSED_STORAGE_KEY = 'nora-debug-collapsed'

/**
 * Configurazioni client precaricabili per test rapido dei flussi.
 * Derivate da configClients.json (BusinessAI) — solo campi rilevanti per il test,
 * senza credenziali/segreti.
 */
export const CLIENT_CONFIGS = [
  {
    id: 'siap_dev',
    label: 'SIAP (Frigerio dev)',
    description: 'Flusso Frigerio su ambiente SIAP test',
    typeEndpointCall: 'frigerioFlow',
    tomcatCode: 'OUTS',
    codSociety: '69',
    communicationChannel: 'email',
    userEmail: 'testnora@siap.cloud',
    processLoadQuotes: 'frigerioQuotes',
    unitCallConversationExist: ['checkBuonoBruttoCattivo']
  },
  {
    id: 'frigerio_prod',
    label: 'Frigerio (produzione)',
    description: 'Flusso Frigerio con OAuth2 email',
    typeEndpointCall: 'frigerioFlow',
    tomcatCode: 'OUTS',
    codSociety: '69',
    communicationChannel: 'email',
    userEmail: 'enrica@frigerioviaggi.com',
    processLoadQuotes: 'frigerioQuotes',
    errorProcessToLoad: 'redirectFlowTicket',
    unitCallConversationExist: ['checkBuonoBruttoCattivo'],
    escludeMidOfficeFlow: true
  },
  {
    id: 'gattinoni_prod',
    label: 'Gattinoni (produzione)',
    description: 'Flusso Gattinoni via Front',
    typeEndpointCall: 'gattinoniFlow',
    tomcatCode: 'ONYX',
    codSociety: 'G3',
    communicationChannel: 'email',
    userEmail: 'mranocchia@siapcn.it',
    processLoadQuotes: 'gattinoniQuotes',
    errorProcessToLoad: 'errorProcessingConversationFront',
    unitCallConversationExist: ['finalProcessingConversationFront']
  },
  {
    id: 'goelett_test',
    label: 'Goelett (test)',
    description: 'Flusso Goelett con preventivo interattivo',
    typeEndpointCall: 'goelettFlow',
    tomcatCode: 'EXTRA',
    codSociety: 'GOE',
    communicationChannel: 'email',
    userEmail: 'test6.nora@test.com',
    processLoadQuotes: 'goelettQuotes',
    errorProcessToLoad: 'humanEscalationGoelett',
    selfManagedDataCollection: true,
    dataQuestionUnit: 'goelettGenerateQuestionMissingData',
    escludeMidOfficeFlow: true,
    testUsers: [
      { email: 'test1.nora@test.com', role: 'Self-booker' },
      { email: 'test2.nora@test.com', role: 'Self-booker' },
      { email: 'test3.nora@test.com', role: 'Arranger' },
      { email: 'test4.nora@test.com', role: 'Approver' },
      { email: 'test5.nora@test.com', role: 'Approver' },
      {
        email: 'test6.nora@test.com',
        role: 'Self-booker',
        note: 'Happy path, recommended for start'
      }
    ]
  }
]
